
import {
    Col,
    Input,
    Label,
} from "reactstrap";

const OtpMobileForm = ({ contactInfo, countryCode, setCountryCode, setContactInfo }) => {

    return (
        <>
                  <Col lg={12} className="mb-3">
                    <div className="input-group">
                      <select
                        className="form-select"
                        style={{ maxWidth: "100px" }}
                        value={countryCode}
                        onChange={(e) => setCountryCode(e.target.value)}
                      >
                        <option value="+977">+977</option>
                        <option value="+91">+91</option>
                        <option value="+1">+1</option>
                        <option value="+81">+44</option>
                        <option value="+61">+61</option>
                      </select>
                      <div className="form-floating flex-grow-1">
                        <Input
                          type="tel"
                          placeholder="Enter 10-digit mobile number"
                          value={contactInfo}
                          onChange={(e) => setContactInfo(e.target.value)}
                          className="form-control"
                          aria-describedby="mobile_number_error"
                          style={{
                            padding: "0.75rem 0.75rem 0.8rem 0.75rem",
                          }}
                        />
                        <Label for="mobile_number" className="form-label">
                          Enter Mobile Number
                        </Label>
                      </div>
                    </div>
                  </Col>
        </>
    );
};

export default OtpMobileForm;
